import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import CommentForm from './CommentForm'
import Replies from './Replies'
/* REDUX */
import { connect } from 'react-redux'
import { loadComments, deleteComment } from '../../actions/comments'
import { formatDate } from '../../utility/Formatter'

class Top extends React.Component {
	
	constructor(props) {
		super(props)
		this.handleProfile = this.handleProfile.bind(this)
	}
	
	handleProfile(e) {
		e.preventDefault()
		const { user, routerHistory } = this.props
		const { username } = user
		routerHistory.push('/profile/' + username)
	}
	
	render() {
		
		const {  user, created, author_id } = this.props
		const { _id, profile_picture, name } = user
		
		let formattedDate = formatDate(created)
		
		let user_img = profile_picture && profile_picture != 'undefined' ?  profile_picture : 'https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=32da20ee-1450-44b5-ad37-04b317d18f04'
		
		return (
			
			<div className="top">
				<div className="left">
					<img src={ user_img } onClick={ this.handleProfile } />
				</div>
				<div className="right">
					<div className="bio">
						{author_id === _id ? (
							<span className="name owner" onClick={ this.handleProfile }>{ name }</span>
						) : (
							<span className="name" onClick={ this.handleProfile }>{ name }</span>	
						)}
						<span className="date">{ formattedDate }</span>
					</div>
				</div>
			</div>
			
		)
	}
}

class Comment extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			showReply: false
		}
		this.toggleReply = this.toggleReply.bind(this)
		this.handleDelete = this.handleDelete.bind(this)
	}
	
	toggleReply() {
		this.setState({
			showReply: !this.state.showReply
		})
	}
	
	handleDelete() {
		const comment_id = this.props._id
		const report_id = this.props.report_id
		this.props.deleteComment(comment_id, report_id)
	}
	
	render() {
		
		const { report_id, user_id, author_id, _user, created, comment, replies, routerHistory } = this.props
		const { _id, profile_picture, name } = _user
		
		let formattedDate = formatDate(created)
		let repliesCount = replies.length
		
		return (
			<div className="comment">
				<Top user={ _user } created={ created } routerHistory={ routerHistory } author_id={ author_id } />
				<div className="mid">
					<p className="text">{ comment }</p>
				</div>
				{user_id === _id ? (
					<div className="bot">
						<span className="bit" onClick={ this.toggleReply }><span className="text">Replies ({ repliesCount })</span></span>
						<span className="bit ml-2" onClick={ this.handleDelete }><span className="text">Delete</span></span>
					</div>
				):(
					<div className="bot">
						<span className="bit" onClick={ this.toggleReply }><span className="text">Replies ({ repliesCount })</span></span>
						<span className="bit float-right"><i className="fa fa-flag-o"></i><span>Flag</span></span>
					</div>
				)}
				{this.state.showReply ? (
					<Replies report_id={ report_id } comment_id={ this.props._id } author_id={ author_id } onLogin={ this.props.onLogin } />
				) :(
					<div></div>
				)}
			</div>
		)
	}
}

const loadData = ({ report_id, loadComments }) => {
	loadComments(report_id)
}

class Comments extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.report_id !== this.props.report_id) {
			loadData(nextProps)
		}
	}
	
	handleLoadMoreClick = () => {
		this.props.loadComments(this.props.report_id, true)
	}
	
	render() {
		
		const { report_id, user_id, author_id, comments, endOfDoc, deleteComment, history } = this.props
		
		let commentsList
		
		if (comments.length > 0 ) {
			commentsList = comments.map(comment => {
				return <Comment key={ comment._id } {...comment} author_id={ author_id } user_id={ user_id } report_id={ report_id } onLogin={ this.props.onLogin } deleteComment={ deleteComment } routerHistory={ history } />
			})
		} else {
			commentsList = <div></div>
		}
				
		return (
			<div className="comments">
				<div className="form-wrapper">
					<CommentForm onLogin={ this.props.onLogin } report_id={ this.props.report_id } />
				</div>
				<div className="wrapper">
					<label className="heading">Discussion Feed</label>
					{ commentsList }
					<div>
					{!endOfDoc ? (
						<div className="fin" style={{cursor:"pointer"}}>
							<span className="text active" onClick={ this.handleLoadMoreClick } style={{cursor:"pointer"}}>Show More</span>
						</div>
					):(
						<div className="fin">
							<span className="text">End of Discussion</span>
						</div>
					)}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.params.report_id
	const {
		commentsById,
		reportById,
		auth
	} = state
	const user_id = auth.user_id
	const reportWrapper = reportById[report_id] || { report: {} }
	const report = reportWrapper.report
	const author = report._user || {}
	const author_id = author._id
	const commentsWrapper = commentsById[report_id] || { comments: { } }
	const comments = commentsWrapper.comments
	const endOfDoc = commentsWrapper.endOfDoc
	return {
		user_id,
		author_id,
		report_id,
		comments,
		endOfDoc
	}
}

export default withRouter(connect(mapStateToProps, { loadComments, deleteComment })(Comments))


// WEBPACK FOOTER //
// ./src/components/Report/Comments.js